import { useState, useEffect } from 'react';
import { SettingCard, SettingField, SettingActions, SettingAddButton, useSettingEditing } from './SettingControls';
import butterflyApi from "../../ButterflyApi";

const FRIEND_GROUP_NO = 2
const FRIEND_FIRSTNAME_FEATURE_NO = 1
const FRIEND_LASTNAME_FEATURE_NO = 14
const FRIEND_GENDER_FEATURE_NO = 13

const Friend = ({ features, ordering, heroNo, onDelete, index, setLoading, reloading, editing, setEditing }) => {

  const [firstName, setFirstName] = useState('')
  const [firstNameFeatureContentNo, setFirstNameFeatureContentNo] = useState(0)
  const [lastName, setLastName] = useState('')
  const [lastNameFeatureContentNo, setLastNameFeatureContentNo] = useState(0)
  const [gender, setGender] = useState('')
  const [genderFeatureContentNo, setGenderFeatureContentNo] = useState(0)
  const [originFeature, setOriginFeature] = useState()
  const [updated, setUpdated] = useState(false)

  useEffect(() => {
    if (!features) {
      setOriginFeature({
        firstName: '',
        lastName: '',
        gender: ''
      })
      return
    }
    const firstNameFeature = features.filter(feature => feature.heroFeatureNo == FRIEND_FIRSTNAME_FEATURE_NO)[0];
    const lastNameFeature = features.filter(feature => feature.heroFeatureNo == FRIEND_LASTNAME_FEATURE_NO)[0];
    const genderFeature = features.filter(feature => feature.heroFeatureNo == FRIEND_GENDER_FEATURE_NO)[0];
    setFirstName(firstNameFeature?.answer || '')
    setFirstNameFeatureContentNo(firstNameFeature?.heroFeatureContentNo)
    setLastName(lastNameFeature?.answer || '')
    setLastNameFeatureContentNo(lastNameFeature?.heroFeatureContentNo)
    setGender(genderFeature?.answer || '')
    setGenderFeatureContentNo(genderFeature?.heroFeatureContentNo)
    setOriginFeature({
      firstName: firstNameFeature?.answer || '',
      lastName: lastNameFeature?.answer || '',
      gender: genderFeature?.answer || '',
    })
    setUpdated(false)
  }, [features])

  useEffect(() => {
    if (!originFeature) return
    if (firstName != originFeature.firstName) {
      setUpdated(true)
      return
    }
    if (lastName != originFeature.lastName) {
      setUpdated(true)
      return
    }
    if (gender != originFeature.gender) {
      setUpdated(true)
      return
    }
    setUpdated(false)
  }, [firstName, lastName, gender, originFeature])

  useSettingEditing(updated, setEditing)

  const _onDelete = async () => {
    if (firstName || lastName || gender) {
      if (!window.confirm("입력된 내용이 있습니다. 그래도 삭제하시겠나요?")) {
        return
      }
    }
    if (index > 0) {
      onDelete(index)
      return
    }
    setLoading(true)
    const featureContentNos = [firstNameFeatureContentNo, lastNameFeatureContentNo, genderFeatureContentNo]
    await butterflyApi.deleteHeroFeatures(heroNo, featureContentNos.filter(v => v).join(','))
    setLoading(false)
    reloading()

  }

  const onSave = async () => {
    if (!gender) {
      alert('성별을 선택해 주세요.')
      return
    }
    if (!firstName) {
      alert('이름을 입력해 주세요.')
      return
    }
    const models = []
    if (firstName) {
      models.push({
        heroFeatureContentNo: firstNameFeatureContentNo,
        answer: firstName,
        ordering: ordering || index,
        heroFeatureNo: FRIEND_FIRSTNAME_FEATURE_NO
      })
    }
    if (lastName) {
      models.push({
        heroFeatureContentNo: lastNameFeatureContentNo,
        answer: lastName,
        ordering: ordering || index,
        heroFeatureNo: FRIEND_LASTNAME_FEATURE_NO
      })
    }
    if (gender) {
      models.push({
        heroFeatureContentNo: genderFeatureContentNo,
        answer: gender,
        ordering: ordering || index,
        heroFeatureNo: FRIEND_GENDER_FEATURE_NO
      })
    }
    setLoading(true)
    await butterflyApi.updateHeroFeatures(heroNo, models)
    setLoading(false)
    reloading()
  }

  const onCancel = () => {
    setFirstName(originFeature.firstName)
    setLastName(originFeature.lastName)
    setGender(originFeature.gender)
  }

  return <SettingCard label={features ? `${features.find(feature => feature.heroFeatureNo === FRIEND_FIRSTNAME_FEATURE_NO)?.answer || '친구'} 친구` : '새 친구'} updated={updated} disabled={editing && !updated} onDelete={_onDelete}>
    <div className="setting-fields">
      <SettingField label="성" value={lastName} placeholder="김" onChange={e => setLastName(e.target.value)} />
      <SettingField label="이름" value={firstName} placeholder="친구의 이름" onChange={e => setFirstName(e.target.value)} />
    </div>
    <SettingField label="성별" as="select" value={gender} onChange={e => setGender(e.target.value)}>
      <option value="">성별을 선택해 주세요</option>
      <option value="남">남자아이</option><option value="여">여자아이</option>
    </SettingField>
    {updated && <SettingActions onSave={onSave} onCancel={onCancel} />}
  </SettingCard>
}

const FriendSetting = ({ heroNo, setLoading, editing, setEditing }) => {

  const [friendFeaturesByOrder, setFriendFeaturesByOrder] = useState()
  const [addFriend, setAddFriend] = useState([])

  const load = async () => {
    if (!heroNo) return
    const data = await butterflyApi.getHeroFeatures(heroNo)
    const friendFeatures = data.items.filter(item => item.groupNo == FRIEND_GROUP_NO)
    const _friendFeaturesByOrder = Object.groupBy(friendFeatures, (item) => item.ordering)
    setFriendFeaturesByOrder(_friendFeaturesByOrder)
  }

  useEffect(() => {
    load();
  }, [heroNo])

  const maxOrdering = (friendFeaturesByOrder && Object.keys(friendFeaturesByOrder).length > 0) ? Math.max(...Object.keys(friendFeaturesByOrder)) : 0

  return <div className="setting-stack">
    {friendFeaturesByOrder && Object.keys(friendFeaturesByOrder).length === 0 && addFriend.length === 0 && <p className="settings-empty">아이와 모험을 함께할 단짝 친구가 있나요?</p>}
    {
      friendFeaturesByOrder && Object.keys(friendFeaturesByOrder).map(key => {
        const features = friendFeaturesByOrder[key]
        return <Friend key={features[0].ordering} heroNo={heroNo} ordering={features[0].ordering} features={features} setLoading={setLoading} reloading={load} editing={editing} setEditing={setEditing} />
      })
    }
    {
      addFriend.map((i) => {
        return <Friend key={i} index={i} heroNo={heroNo} setLoading={setLoading} editing={editing} setEditing={setEditing} onDelete={(i) => {
          const _addFriend = addFriend.filter(el => el != i)
          setAddFriend(_addFriend)
        }} reloading={() => {
          const _addFriend = addFriend.filter(el => el != i)
          setAddFriend(_addFriend)
          load()
        }} />
      })
    }
    <SettingAddButton disabled={editing} onClick={() => {
      const max = Math.max(maxOrdering, ...addFriend)
      setAddFriend(current => current.concat(max + 1))
    }}>친구 추가하기</SettingAddButton>
  </div>
}

export default FriendSetting
